import * as React from 'react';

export class EventHelper {
    static isKeyEnterEvent(event: React.KeyboardEvent<HTMLInputElement>): boolean {
        const { key } = event;
        const enterKey = 'Enter';
        return key === enterKey;
    }
}